import {DesktopAddButtonWrapper, DesktopFixedAddButton, MobileBottomWrapper} from "widgets/hud/ui/styles.ts";
import {MOBILE_BOTTOM_NAV} from "widgets/hud/model/routes.ts";
import {HudButton} from "widgets/hud/ui/HudButton";
import { Button } from "@atomaro/ui-kit";
import { AddLarge } from "shared/ui/icons";
import { useGlobalStore } from "entities/global";
import {SettingsModal} from "widgets/profile";

export const MobileBottom = () => {
  const plusButtonCallback = useGlobalStore(s => s.plusButtonCallback);

    return (
        <>
            <MobileBottomWrapper className="MobileBottomWrapper">
                {MOBILE_BOTTOM_NAV.map((item) => (
                    <HudButton item={item} key={item.id} isMobileMenu={true}/>
                ))}
            </MobileBottomWrapper>
            <DesktopFixedAddButton>
                <DesktopAddButtonWrapper style={{height: "100%"}}>
                    {plusButtonCallback && <Button
                        label={""}
                        style={{height: "100%"}}
                        variant={"primary"}
                        size={"m"}
                        iconPrefix={<AddLarge />}
                        onClick={() => plusButtonCallback?.()}
                    />}
                </DesktopAddButtonWrapper>
            </DesktopFixedAddButton>
          <SettingsModal />
        </>
    );
};

export default MobileBottom;
